import { useSamplingProcedure } from "@services/servicesGenericsTables";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";

const useFilterSamplingProcedure = (codop) => {
  const form = useFormContext();
  const { procedureList } = useSamplingProcedure();

  const filterSamplingProcedureList = useMemo(() => {
    const codigo = form.getValues("malpma_procedure")?.codigo;

    return procedureList.filter(
      (procedure) => procedure.codop === codop && procedure.codigo === codigo
    );
  }, [procedureList, codop]);

  return filterSamplingProcedureList;
};

export default useFilterSamplingProcedure;
